import { render, staticRenderFns } from "./room-summary.vue?vue&type=template&id=46c190d8&scoped=true&"
import script from "./room-summary.vue?vue&type=script&lang=js&"
export * from "./room-summary.vue?vue&type=script&lang=js&"
import style0 from "./room-summary.vue?vue&type=style&index=0&id=46c190d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c190d8",
  null
  
)

export default component.exports